import React from "react";

export const SearchIcon = (props) => {
    return (
        <>

            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.4951 17.4902C6.90796 17.4902 4 14.5823 4 10.9951C4 7.40796 6.90796 4.5 10.4951 4.5C14.0823 4.5 16.9902 7.40796 16.9902 10.9951C16.9902 12.4961 16.4811 13.8781 15.6262 14.978L20 19.3518L18.8518 20.5L14.478 16.1262C13.3781 16.9811 11.9961 17.4902 10.4951 17.4902ZM15.3677 10.9963C15.3677 13.6867 13.1867 15.8677 10.4963 15.8677C7.80597 15.8677 5.625 13.6867 5.625 10.9963C5.625 8.30597 7.80597 6.125 10.4963 6.125C13.1867 6.125 15.3677 8.30597 15.3677 10.9963Z" fill="#B1B5C4" />
            </svg>

        </>
    )
}